export const EMPTY_STRING = '';
export const DELIMITER = '|';
export const PREFIX = `UBI${DELIMITER}`;
//# sourceMappingURL=constants.js.map